import api from '../../baseApi';
import {isDebugging} from '../../../utility';
import {AxiosResponse} from 'axios';

export type Request = {
  subID: number;
  userID: number;
  email: string;
  firstName: string;
  lastName: string;
  title: string;
};

type Response = {
  status: 'SUCCESS' | 'FAILURE';
  message: string;
};

const editSubAccountPort = '/modifySubAccount';

const editSubAccountAPI = async (subAccount: Request): Promise<AxiosResponse<Response>> => {
  const res = await api.post(editSubAccountPort, subAccount);

  if (isDebugging) {
    console.log(`${editSubAccountPort} response:`, res);//TESTING
  }

  return res;
};

export default editSubAccountAPI;